import type { ISaleRepository, ListSalesParams, ListSalesResult } from '../repositories/ISaleRepository.js';

export function createListSalesUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function listSalesUseCase(params: ListSalesParams): Promise<ListSalesResult> {
    return deps.saleRepository.listSales(params);
  };
}

export type ListSalesUseCase = ReturnType<typeof createListSalesUseCase>;
